import _ from 'lodash'
import Wizard from 'scoreboard/components/wizard'
import RestConnectionMetadata from 'scoreboard/admin/connections/rest/rest-connection-metadata'
import RestConnectionBaseUrl from 'scoreboard/admin/connections/rest/rest-connection-base-url'
import RestConnectionLabelAndOwners from 'scoreboard/admin/connections/rest/rest-connection-label-and-owners'
import RestConnectionRefreshToken from 'scoreboard/admin/connections/rest/rest-connection-refresh-token'
import WsAuthenticationType from 'scoreboard/admin/model/ws-authentication-type'
const { OAUTH_V2 } = WsAuthenticationType

const RestConnectionWizard = Wizard.extend({

	/**
	 * Wizard for creating REST web service import connections (#50596)
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @params {Connection} options.model
	 */
	initialize: function(options = {}) {
		this.model = options.model
		const views = this.getViews()
		const opts = _.extend({ views }, options)
		Wizard.prototype.initialize.call(this, opts)
	},

	getViews: function() {
		const views = [ RestConnectionMetadata, RestConnectionBaseUrl, RestConnectionLabelAndOwners ]
		const attrs = this.model.attributes
		if (attrs.wsAuthenticationType === OAUTH_V2 && !_.isNil(attrs.refreshToken)) {
			views.splice(1, 0, RestConnectionRefreshToken)
		}
		return views
	},

	next: function() {
		this.setViews(this.getViews())
		Wizard.prototype.next.apply(this, arguments)
	}

})

export default RestConnectionWizard

RestConnectionWizard.__filename__ = 'admin/connections/rest/rest-connection-wizard.js'
